import React, { Component } from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import './Calculator.css';

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
    fontSize: state.fontSize,
  }
}

class Calculator extends Component {
  render() {

    const {
      fonts,
    } = this.props;


    const {
      primary,
      secondary
    } = fonts;

    const styles = {
      primaryFont: {
        fontFamily: primary.name
      },
      secondaryFont: {
        fontFamily: secondary.name
      },
    }

    return (
      <Paper
        zDepth={1}
        className="phone-wrapper">
        <div className="calculator-header">
          <div style={styles.primaryFont}
            className="main-numbers">
            197
          </div>
          <div style={styles.secondaryFont}
            className="ongoing-calculation">
            14 + 22 + 73 + 50 + 52 + 14
          </div>
        </div>
        <div className="calculator-input-container">
          <table className="calculator-table"
            style={styles.primaryFont}>
            <tbody>
              <tr>
                <td className="top-row">AC</td>
                <td className="top-row">+ / -</td>
                <td className="top-row">%</td>
                <td className="top-row">&times;</td>
              </tr>
              <tr>
                <td className="numbers-cell">7</td>
                <td className="numbers-cell">8</td>
                <td className="numbers-cell">9</td>
                <td className="top-row">/</td>
              </tr>
              <tr>
                <td className="numbers-cell">4</td>
                <td className="numbers-cell">5</td>
                <td className="numbers-cell">6</td>
                <td className="top-row">-</td>
              </tr>
              <tr>
                <td className="numbers-cell">1</td>
                <td className="numbers-cell">2</td>
                <td className="numbers-cell">3</td>
                <td className="top-row">+</td>
              </tr>
              <tr>
                <td className="numbers-cell" colSpan="2">0</td>
                <td className="numbers-cell">.</td>
                <td className="equals-cell">=</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Paper>
    )
  }
}

export default Calculator = connect(mapStateToProps, undefined)(Calculator);



// WEBPACK FOOTER //
// ./src/components/generator/elements/Calculator.jsx